

import { useContext, useEffect, useRef, useState } from "react";
import './index.less'
import { SideHeader, ContextMenu, MenuList, MenuItem, TnModal, FloatModal, IconButton } from "bimui";
import { Skeleton, Table, message } from "antd";

import { User } from "@/declare/interface/project/user";
import classNames from 'classnames';
import { ReactComponent as AddSvg } from 'bimui/dist/c1/icons/new-default.svg';
import UserModal from "./user-model";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { deleteProject, deleteProjectUsersBatch, findProjectUsers } from '@/declare/api/project/project-user';
import { ReactComponent as CustomizeSvg } from 'bimui/dist/c1/icons/customize.svg';
import { ReactComponent as AssignTaskSvg } from 'bimui/dist/c1/icons/assign-task.svg';
import { ReactComponent as PermissionSettingSvg } from 'bimui/dist/c1/icons/permission-setting.svg';
import UserDrawer from "./user-drawer";
import { NavigationContext, RegisterContext } from "@/App";
import { RegisterStatus } from "@/store/register-store";
import { emitter } from '@/utils/mitt';
import { Emit_Event_Common_Tool } from '@/declare/enums/emit-event';
import { BaseUtils } from 'tnbase';
import { ReactComponent as SelectedSvg } from './icons/selected.svg';
import { ReactComponent as SuspensionSvg } from './icons/suspension.svg';
import { getUsers } from "@/declare/api/project/user";
import { ReactComponent as FilterSvg } from './icons/filter.svg';
import { SIDEBAR_TYPE } from "@/declare/enums/menu-type";
import localStore from "@/store/local-store";

/**
 * 用户 侧边栏面板
 * @param props 
 * @returns 
 */
export default function ProjectUserPanel() {
    const location = useLocation();
    const navigate = useNavigate();
    const registerContext = useContext<RegisterStatus>(RegisterContext);
    const navigationContext = useContext(NavigationContext);
    /**
     * 从 URL 中提取项目 UUID 参数
     */
    const { projectUuid } = useParams();
    /**
     * 控制右键菜单是否显示
     */
    const [cmOpen, setCmOpen] = useState<boolean>(false);
    /**
     * 右键菜单的纵坐标位置
     */
    const [cmTop, setCmTop] = useState<number>();
    /**
     * 右键菜单的横坐标位置
     */
    const [cmLeft, setCmLeft] = useState<number>();
    /**
     * 显示系统库的用户列表数据
     */
    const [user, setUser] = useState<User[]>([]);
    /**
     * 存储显示的用户列表数据(当前项目关联的用户列表)
     */
    const [displayUsers, setDisplayUsers] = useState<User[]>([]);
    /**
     * 当前右键选中的项目库用户（仅用于判断当前邮件是否成功选中表格内容)
     */
    const [activeItem, setActiveItem] = useState<User>();
    /**
     * 当前双击选中的用户选项
     */
    const [detailItem, setDetailItem] = useState<User>();
    /**
     * 控制用户信息弹窗的显示状态
     */
    const [showModal, setShowModal] = useState<boolean>(false);
    /**
     * 控制新建用户到项目的弹窗的显示状态
     */
    const [showAddSide, setShowAddSide] = useState<boolean>(false);

    /**
     * 当前单击选中的用户选项数组（参考window可以储存多选选中的用户信息）
     */
    const [selecItems, setSelecItems] = useState<User[]>();

    const [hoveredItem, setHoveredItem] = useState<User | null>(null); // 用于存储当前悬浮的行

    const isDbClickRef = useRef<boolean>(false);    // 是否双击

    /**
     * 记录最后一次单击的行索引
     */
    const [lastSelectedIndex, setLastSelectedIndex] = useState<number | null>(null);
    /**
     * ctrl键是否被按下
     */
    const [ctrlPressed, setCtrlPressed] = useState<boolean>(false);
    /**
     * shift 键是否被按下
     */
    const [shiftPressed, setShiftPressed] = useState<boolean>(false);
    /**
    * 页签上下文
    */
    const navigateContext = useContext(NavigationContext);

    const [jobFilters, setJobFilters] = useState<{ text: string; value: string }[]>([]); // 职位筛选列表
    const [majorFilters, setMajorFilters] = useState<{ text: string; value: string }[]>([]); // 专业筛选列表


    const [isEditing, setIsEditing] = useState<boolean>(false);

    const [deleteFlag, setDeleteFlag] = useState<string>("");
    const [editFlag, setEditFlag] = useState<string>("");

    useEffect(() => {
        let status = localStore.getSidebarStatus(SIDEBAR_TYPE.USER);
        setSelecItems(status['selecItems'] || []);
    }, [])

    useEffect(()=>{
        updateStatus(selecItems);
    },[selecItems])

    const updateStatus = (selecItems: any) => {
        // 在这里向外传递状态
        let status = {
            selecItems: selecItems,
        };
        localStore.setSidebarStatus(SIDEBAR_TYPE.USER, status);
    }

    useEffect(() => {
        navigateContext.registTab({
            key: location.pathname,
            value: `用户`,
        })
        navigateContext.setActiveTabKey(location.pathname)
    }, [])

    useEffect(() => {
        const handleDelete = () => setDeleteFlag(BaseUtils.genUUID());
        const handleEdit = () => setEditFlag(BaseUtils.genUUID());

        emitter.on(Emit_Event_Common_Tool.DELETE, handleDelete);
        emitter.on(Emit_Event_Common_Tool.EDIT, handleEdit);

        return () => {
            emitter.off(Emit_Event_Common_Tool.DELETE, handleDelete);
            emitter.off(Emit_Event_Common_Tool.EDIT, handleEdit);
        };
    }, []);

    useEffect(() => {
        if (!deleteFlag || selecItems.length === 0) return;
        onDelete();
    }, [deleteFlag]);

    useEffect(() => {
        if (!editFlag || selecItems.length === 0) return;
        setIsEditing(true);
        setDetailItem(selecItems[0]);
        setShowModal(true);
        setCmOpen(false);
    }, [editFlag]);

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Control") setCtrlPressed(true);
            if (e.key === "Shift") setShiftPressed(true);
        };

        const handleKeyUp = (e: KeyboardEvent) => {
            if (e.key === "Control") setCtrlPressed(false);
            if (e.key === "Shift") setShiftPressed(false);
        };

        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("keyup", handleKeyUp);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("keyup", handleKeyUp);
        };
    }, []);


    /**
     * 组件初始化时加载用户数据
     */
    useEffect(() => {
        generateData();
    }, [])
    /**
     * 查询用户数据
     * 调用后端接口 `findProjectUsers` 获取项目下的用户信息并更新状态
     */
    const generateData = () => {
        findProjectUsers(projectUuid).then(res => {
            setDisplayUsers(res.data || []);
            return getUsers(); // 获取系统库用户数据
        })
            .then((resAll) => {
                setUser(resAll.data || []); // 设置系统库用户数据
                const allUsers = resAll.data;

                // 生成职位、专业筛选列表，确保类型为 string
                const uniqueJobs = Array.from(new Set(allUsers.map((item) => item.job).filter(Boolean))) as string[];
                const uniqueMajors = Array.from(new Set(allUsers.map((item) => item.major).filter(Boolean))) as string[];

                setJobFilters(uniqueJobs.map((job) => ({ text: job, value: job })));
                setMajorFilters(uniqueMajors.map((major) => ({ text: major, value: major })));

            })
            .catch((err) => {
                message.error("获取用户数据失败");
            });
    };

    /**
     * 处理左键点击表格行的事件
     * 该操作会展示被点击行的详细信息
     */
    const handleRowClick = (record: User, index: number) => {
        isDbClickRef.current = false;
        setTimeout(() => {
            if (isDbClickRef.current) return;
            setActiveItem(null);
            setDetailItem(null);
            if (ctrlPressed) {
                // Ctrl + 单击：多选/取消选中
                if (selecItems.some(item => item.uuid === record.uuid)) {
                    // 如果已选中，移除
                    setSelecItems(selecItems.filter(item => item.uuid !== record.uuid));
                } else {
                    // 如果未选中，添加
                    setSelecItems([...selecItems, record]);
                }
            } else if (shiftPressed && lastSelectedIndex !== null) {
                // Shift + 单击：区间选择
                const start = Math.min(lastSelectedIndex, index);
                const end = Math.max(lastSelectedIndex, index);
                const rangeItems = displayUsers.slice(start, end + 1);

                setSelecItems(prev => {
                    const selectedUuids = prev.map(item => item.uuid);
                    const newItems = rangeItems.filter(item => !selectedUuids.includes(item.uuid)); // 过滤出未选中的
                    return [...prev, ...newItems];
                });
            } else {
                // 单击：单选
                if (selecItems.some(item => item.uuid === record.uuid)) {
                    setSelecItems([]);
                } else {
                    setSelecItems([record]);
                }
            }

            setLastSelectedIndex(index); // 更新最后一次点击的索引
        }, 150)
    };

    /**
     * 用户列表行右键点击事件处理
     * @param e 鼠标事件
     * @param record 当前点击的用户数据
     */
    const onRowRightClick = (e: React.MouseEvent, record: User) => {
        e.preventDefault();

        // 判断当前点击的对象是否已经在选中的列表中
        const isAlreadySelected = selecItems.some(item => item.uuid === record.uuid);

        if (!isAlreadySelected) {
            // 如果不在选中列表中，则清空 selecItems，并只选中当前点击的对象
            setSelecItems([record]);
        }
        setCmLeft(e.clientX);
        setCmTop(e.clientY);
        setDetailItem(null);
        setCmOpen(true);
    }
    /**
     * 用户弹窗编辑保存操作处理
     * @param type 操作类型：'create' 或 'update'
     * @param user 用户信息
     */
    const onSave = (selectedItems: User[]) => {
        setDisplayUsers(selectedItems); // 更新 displayUsers 列表
        setShowModal(false);
        setDetailItem(null);
        setActiveItem(null);
        setSelecItems([]);
    }
    /**
     * 删除用户操作
     * 显示确认弹窗，确认后调用后端删除接口
     */
    const onDelete = () => {

        // 获取需要删除的用户 UUID 列表
        const uuidsToDelete = selecItems.map(item => item.uuid);

        if (uuidsToDelete.length === 0) {
            message.warning("请选择要删除的用户");
            return;
        }

        // 检查 selecItems 的 tasksCount 是否全部为空
        const allTasksEmpty = selecItems.every(item => !item.tasksCount); // 如果 tasksCount 全部为空，则返回 true

        if (allTasksEmpty) {
            // 如果所有任务为空，直接删除
            handleBatchDelete(uuidsToDelete);
            return;
        }

        // 如果 tasksCount 不为空，显示确认弹窗
        TnModal().deleteModal({
            onOk() {
                TnModal().destoryAll();
                handleBatchDelete(uuidsToDelete);
            },
            onCancel() {
                setCmOpen(false);
                setActiveItem(null);
                TnModal().destoryAll();
            },
        });
    };


    /**
     * 执行批量删除逻辑
     * @param uuidsToDelete 用户 UUID 列表
     */
    const handleBatchDelete = (uuidsToDelete: string[]) => {
        deleteProjectUsersBatch(projectUuid, uuidsToDelete)
            .then((response) => {
                if (response.status === 200) {
                    // 更新显示的用户列表
                    const remainingUsers = displayUsers.filter(
                        item => !uuidsToDelete.includes(item.uuid)
                    );
                    setDisplayUsers(remainingUsers);
                }
            })
            .catch((err) => {
                message.error("删除失败，请稍后重试");
            })
            .finally(() => {
                setActiveItem(null);
                setSelecItems([]);
                setCmOpen(false);
            });
    };

    /**
     * 系统库添加用户操作（跳转到用户库侧边栏）
     */
    const addUser = () => {
        setActiveItem(null); // 清空用户信息
        setDetailItem(null); // 清空详情项
        setSelecItems([]);
        setCmOpen(false);
        setShowAddSide(true);
    };

    /**
     * 查看编辑用户操作
     * 设置弹窗标题为 "编辑用户"，显示弹窗
     */
    const viewDetails = () => {
        if (selecItems.length === 0) return; // 如果没有选中的项，直接返回
        setIsEditing(false);
        setDetailItem(selecItems[0]); // 使用 selecItems 的第一个选中项
        setShowModal(true);
        setCmOpen(false);
    };

    const editDetails = () => {
        if (selecItems.length === 0) return; // 如果没有选中的项，直接返回
        setIsEditing(true);
        setDetailItem(selecItems[0]); // 使用 selecItems 的第一个选中项
        setShowModal(true);
        setCmOpen(false);
    };

    /**
     * 处理库添加用户列表的保存时间
     * 将在库添加列表的新添加或者去除的新项目列表保存到 displayUsers 列表中
     */
    const handleUserSave = (selectedItems: User[]) => {
        setDisplayUsers(selectedItems); // 更新 displayUsers 列表
        setShowAddSide(false); // 关闭用户库抽屉
        setDetailItem(null);
        setActiveItem(null);
        setSelecItems([]);
    };


    return (
        <div className="user-side-bar">
            {showAddSide ? (
                // 显示组件 2
                <>
                    <UserDrawer
                        users={user} // 系统库用户数据
                        projectUsers={displayUsers} // 当前项目库用户数据
                        onCancel={() => {
                            setShowAddSide(false);
                        }}
                        onSave={handleUserSave} // 传递回调函数
                    />
                </>
            ) : (
                <>
                    <SideHeader>
                        <div className='user-side-header'>
                            {/* <span>用户</span> */}
                            <AddSvg className='add-icon' onClick={addUser} />
                            <AssignTaskSvg className='add-icon' onClick={() => { }} />
                            <PermissionSettingSvg className='add-icon' onClick={() => { }} />
                        </div>
                    </SideHeader>

                    <div className="user-table-area" onContextMenu={(e) => onRowRightClick(e, null)}>
                        <Table
                            rowKey="uuid" // 数据唯一标识
                            pagination={false} // 禁用分页
                            dataSource={displayUsers || []} // 数据源
                            bordered={false} // 无边框
                            className='tn-common-table' // 自定义表格样式
                            onRow={(record, index) => {
                                return {
                                    onMouseEnter: () => setHoveredItem(record), // 设置悬浮的行
                                    onMouseLeave: () => setHoveredItem(null),  // 清除悬浮状态
                                    onClick: (e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        handleRowClick(record, index);
                                    },
                                    onDoubleClick: (e) => {
                                        // 双击事件，打开用户列表
                                        e.stopPropagation();
                                        e.preventDefault();
                                        isDbClickRef.current = true
                                        setIsEditing(false);
                                        setActiveItem(null);
                                        setSelecItems([record]);
                                        setDetailItem(record);
                                        setShowModal(true); // 显示用户详情弹窗
                                    },
                                    onContextMenu: (e) => {
                                        e.stopPropagation(); // 阻止冒泡
                                        e.preventDefault(); // 阻止默认行为
                                        setActiveItem(record); // 设置选中用户
                                        onRowRightClick(e, record as User); // 右键点击事件
                                    }
                                }
                            }}
                            rowClassName={row => classNames({
                                "common-table-row": true,
                                "common-table-row-active": row.uuid === detailItem?.uuid || selecItems.some(item => item.uuid === row.uuid),
                            })}

                            sticky // 固定表头
                        >
                            <Table.Column dataIndex="name"
                                title="姓名"
                                width={`${80 / 340 * 100}%`}
                                ellipsis
                                sorter={(a: User, b: User) => a.name?.localeCompare(b.name || '')} // 排序规则
                                showSorterTooltip={false} // 不显示排序图标
                            />
                            <Table.Column dataIndex="job" title="职位" width={`${90 / 340 * 100}%`} ellipsis
                                filters={jobFilters} // 筛选器列表

                                onFilter={(value, record) => record.job === value} // 筛选逻辑
                                filterIcon={() => <FilterSvg style={{ cursor: 'pointer' }} />} // 自定义筛选图标

                                sorter={(a: User, b: User) => a.job?.localeCompare(b.job || '')} // 排序规则
                                showSorterTooltip={false} // 不显示排序图标

                            />
                            <Table.Column dataIndex="major" title="专业" width={`${90 / 340 * 100}%`} ellipsis
                                filters={majorFilters} // 添加专业筛选器
                                onFilter={(value, record) => record.major === value} // 筛选逻辑

                                filterIcon={() => <FilterSvg style={{ cursor: 'pointer' }} />} // 自定义筛选图标
                                sorter={(a: User, b: User) => a.major?.localeCompare(b.major || '')} // 排序规则
                                showSorterTooltip={false} // 不显示排序图标

                            />
                            <Table.Column className={classNames({ "link": true })} dataIndex="tasksCount" title="任务数" width={`${80 / 340 * 100}%`} ellipsis
                                sorter={(a: User, b: User) => (a.tasksCount || 0) - (b.tasksCount || 0)} // 按任务数排序

                                showSorterTooltip={false} // 隐藏提示气泡
                                render={(text, record: User) => (
                                    <span
                                        className="clickable-cell"
                                        onClick={() => {
                                            navigationContext.setCurrentSelectUser(record.uuid);
                                            registerContext.activeSidebar(SIDEBAR_TYPE.FILE);
                                            navigate(`/projects/${projectUuid}/files`)
                                        }}
                                    >
                                        {text}
                                    </span>
                                )}
                            />

                        </Table>
                    </div>
                </>
            )}



            {
                showModal && <UserModal
                    showModal={showModal}
                    defaultUser={detailItem} // 将选中的用户信息传递给弹窗
                    edit={isEditing}
                    onEdit={onSave}
                    onCancel={() => {
                        setCmOpen(false);
                        setShowModal(false);
                        setActiveItem(null);
                        setDetailItem(null);
                    }}
                />
            }

            <ContextMenu
                visible={cmOpen} // 是否显示
                top={cmTop} // 菜单纵坐标
                left={cmLeft} // 菜单横坐标
                wrapperClassname='user-list-right-menu' // 自定义右键菜单样式
                onCancel={() => {
                    setCmOpen(false); // 关闭右键菜单
                    setActiveItem(null); // 清空选中用户
                }}
            >
                <MenuList>
                    <MenuItem onClick={addUser}>
                        添加
                    </MenuItem>
                    <MenuItem disabled={activeItem == null} onClick={() => { if (activeItem == null) return; editDetails(); }}>
                        编辑
                    </MenuItem>
                    <MenuItem disabled={activeItem == null} onClick={() => { if (activeItem == null) return; viewDetails(); }}>
                        详情
                    </MenuItem>
                    <MenuItem disabled={activeItem == null} onClick={() => { if (activeItem == null) return; setCmOpen(false); setActiveItem(null) }}>
                        布置任务
                    </MenuItem>
                    <MenuItem disabled={activeItem == null} onClick={() => { if (activeItem == null) return; setCmOpen(false); setActiveItem(null) }}>
                        权限设置
                    </MenuItem>
                    <MenuItem disabled={activeItem == null} onClick={() => { if (activeItem == null) return; onDelete(); }} special>
                        移除
                    </MenuItem>
                </MenuList>
            </ContextMenu>
        </div >
    )
}

